module.exports = __webpack_public_path__ + "static/img/action-pj2.ac612581.png";